import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Your_design",
	"data-name": "Your design",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 670.36 101.81",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M201.42,39.66h16.09c0,4.05,3.12,6,6.67,6,3.27,0,6.39-1.73,6.39-4.83,0-3.55-4.41-4.58-9.79-5.88-8.19-2-18.63-4.54-18.63-17.43C202.15,6.39,210.34,0,223.69,0,237.26,0,245,7,245,18.48H229.4c0-3.58-2.67-5.26-5.9-5.26-2.78,0-5.45,1.21-5.45,3.85,0,3.21,4.27,4.28,9.6,5.62,8.33,2.15,19.22,4.93,19.22,17.85,0,12.37-9.5,18.78-22.64,18.78C210.38,59.32,201.42,52,201.42,39.66Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296.34,15.38H281V57.94H265.31V15.38H249.93v-14h46.41Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332,48.75H311.91l-3.13,9.19H292.07L314.3,1.34h15.24l22.73,56.6H335.1ZM321.91,19l-6.2,17.54h12.46Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M406.16,1.34v56.6H390.42V36.21h-17V57.94H357.71V1.34h15.73V21.76h17V1.34Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M453,43.66V57.94H417.05V1.34h15.8V43.66Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M508.43,1.34v56.6H492.7V36.21h-17V57.94H460V1.34h15.73V21.76h17V1.34Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M553.75,48.75H533.68l-3.13,9.19H513.84l22.23-56.6h15.24L574,57.94H556.86ZM543.68,19l-6.2,17.54h12.46Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M600.73,40.62h-5.66V57.94H579.48V1.34H604c12.2,0,21,8.2,21,20a18.1,18.1,0,0,1-9,16l11.24,20.59h-17.4Zm-5.66-13.14h7.12c4.36,0,6.87-2.62,6.87-6.16s-2.51-6.13-6.87-6.13h-7.12Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M675.36,15.38H660V57.94H644.33V15.38H629v-14h46.41Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M315.77,94H313.4v7.24h-6.51V77.56h10.25c5.1,0,8.8,3.43,8.8,8.37a7.58,7.58,0,0,1-3.76,6.68l4.7,8.61H319.6Zm-2.37-5.49h3a2.59,2.59,0,1,0,0-5.14h-3Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M351.23,95.56v5.66H335.81V77.56H351v5.63H342.3v3.49h7.77V92H342.3v3.54Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M359.48,89.41A12.21,12.21,0,0,1,372.06,77a11.74,11.74,0,0,1,12,10.09h-6.6a5.6,5.6,0,0,0-5.35-4c-3.35,0-5.8,2.69-5.8,6.36s2.45,6.3,5.8,6.3a5.45,5.45,0,0,0,5.36-4.34h6.66a11.81,11.81,0,0,1-12,10.44A12.2,12.2,0,0,1,359.48,89.41Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M402.17,94h-2.36v7.24h-6.52V77.56h10.25c5.1,0,8.8,3.43,8.8,8.37a7.58,7.58,0,0,1-3.76,6.68l4.7,8.61H406Zm-2.36-5.49h3a2.59,2.59,0,1,0,0-5.14h-3Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M422,92.06V77.56h6.66V91.94a3.67,3.67,0,1,0,7.34,0V77.56h6.66v14.5c0,5.82-4.3,9.75-10.33,9.75S422,97.88,422,92.06Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M453,77.56h6.6v23.66H453Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M488,83.43h-6.43v17.79h-6.54V83.43h-6.43V77.56H488Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M497,77.56h6.6v23.66H497Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M535.4,77.56v23.66H530l-9.4-12.84v12.84h-6.32V77.56H520L529.08,90V77.56Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M569.9,88.57c0,7.74-5,13.24-12.46,13.24-7.25,0-12.6-5.21-12.6-12.4A12.08,12.08,0,0,1,557.38,77c6.2,0,11.27,3.88,12.27,9.38h-6.82a5.76,5.76,0,0,0-5.39-3.28c-3.54,0-5.93,2.57-5.93,6.35s2.35,6.3,5.93,6.3c2.49,0,4.62-1.2,5.36-3h-5.87V88.57Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("polygon", { points: "90.63 82.42 94.68 89.43 98.73 82.42 94.68 82.42 90.63 82.42" }),
		/* @__PURE__ */ _jsx("polygon", { points: "104.42 64.5 104.42 56.14 103.39 56.14 98.47 64.5 104.42 64.5" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M180.4,22.39V2.12H61.63V38.49c6.07,3.88,10.1,9.24,10.1,17.75,0,14.9-27.84,28.69-32,29.37L35.59,99.69H74.1A22.93,22.93,0,0,1,91.18,81C86.49,77.54,85,68.49,85,64.8V62.22H83.34V58.07H85V53.25a7.46,7.46,0,0,1,7.45-7.45h14.39a7.45,7.45,0,0,1,7.45,7.45v4.82H116v4.15h-1.69V64.8c0,3.66-1.43,12.58-6,16.13a22.9,22.9,0,0,1,17.42,18.76h39.52L161,85.61C145.64,81.5,128.39,69.31,128.39,57,128.39,32.78,160.69,22.39,180.4,22.39ZM74.93,61.19c0,.33,0,.82-.09,1.43a21.8,21.8,0,0,1-.4,2.22q-.18.63-.36,1.35l-.54,1.45A21.69,21.69,0,0,1,72,70.77,25.36,25.36,0,0,1,69.75,74c-.43.52-.89,1-1.35,1.56s-1,1-1.48,1.5a37.94,37.94,0,0,1-3.27,2.77c-1.14.86-2.33,1.64-3.52,2.4s-2.41,1.39-3.59,2-2.36,1.13-3.48,1.61-2.2.87-3.2,1.22a45.73,45.73,0,0,1-4.92,1.4c-1.2.27-1.9.36-1.9.36L44.78,88c1.1-.53,2.66-1.31,4.51-2.27s4-2.12,6.17-3.44c1.12-.64,2.22-1.39,3.35-2.11s2.25-1.52,3.31-2.36,2.13-1.69,3.14-2.56c.5-.44,1-.9,1.45-1.34s.92-.91,1.35-1.37c.85-.94,1.66-1.86,2.35-2.79S71.7,67.87,72.23,67c.25-.45.49-.87.71-1.28l.58-1.2c.36-.75.59-1.45.83-2l.6-1.83Zm-9.7-50.07V5.9H174.56C174.63,7.41,138.35,11.12,65.23,11.12Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.56,2.12H5C8.58,26.29,38,27.26,56.56,35.77Zm-4.3,9L10.84,5.9H52.26Z",
			transform: "translate(-5)"
		}),
		/* @__PURE__ */ _jsx("polygon", { points: "93.76 64.5 95.57 64.5 100.5 56.14 98.69 56.14 93.76 64.5" }),
		/* @__PURE__ */ _jsx("polygon", { points: "84.93 64.5 92.36 64.5 97.28 56.14 84.93 56.14 84.93 64.5" })
	]
});
export default SvgLogo;
